import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { loginAdministrative } from "../../api/api";
import "./authcustom.css";
import { Link } from "react-router-dom";

function AdministrativeLogin() {
  const [form, setForm] = useState({ identifier: "", password: "" });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState(""); // 'success' or 'error'
  const navigate = useNavigate();
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const popupTypeFromState = location.state?.popupType;
    const popupMessageFromState = location.state?.popupMessage;

    if (popupTypeFromState && popupMessageFromState) {
      setPopupType(popupTypeFromState);
      setSuccess(popupTypeFromState === "success" ? popupMessageFromState : "");
      setError(popupTypeFromState === "error" ? popupMessageFromState : "");
      setShowPopup(true);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setShowPopup(false);
    try {
      // Always send role: 'administrative' in the payload
      const response = await loginAdministrative({ ...form, role: "administrative" });
      // Save token and role to localStorage
      if (response.data && response.data.token) {
        localStorage.setItem("token", response.data.token);
        if (response.data.user && response.data.user.role) {
          localStorage.setItem("role", response.data.user.role);
        } else {
          localStorage.setItem("role", "administrative");
        }
        setSuccess(response.data.message || "Login successful");
        setPopupType("success");
        setShowPopup(true);
        // Delay navigation so popup is visible
        setTimeout(() => {
          navigate("/administrative-login-panel");
        }, 1000);
      }
    } catch (err) {
      setError(err.response?.data?.error || "Login failed");
      setPopupType("error");
      setShowPopup(true);
    }
  };

  // Auto-hide popup after 3 seconds
  useEffect(() => {
    if (showPopup) {
      const timer = setTimeout(() => {
        setShowPopup(false);
        setSuccess("");
        setError("");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showPopup]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', background: 'var(--auth-bg)', paddingTop: '60px' }}>
      <div className="auth-form-container">
        <h2>Administrative Login</h2>
        <form onSubmit={handleSubmit}>
          <label className="auth-label">Mobile or Email
            <input name="identifier" type="text" placeholder="Enter mobile or email" value={form.identifier} onChange={handleChange} required className="auth-input" />
          </label>
          <label className="auth-label">Password
            <div style={{ position: "relative" }}>
              <input name="password" type={showPassword ? "text" : "password"} placeholder="Enter your password" value={form.password} onChange={handleChange} required className="auth-input" autoComplete="current-password" />
              <button type="button" className="auth-show-btn" onClick={() => setShowPassword(s => !s)} tabIndex={-1} aria-label={showPassword ? "Hide password" : "Show password"}>
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </label>
          <button type="submit">Login</button>
        </form>
        <div className="auth-link-container">
          <span>Not registered?</span>
          <Link to="/administrative-register" className="auth-link">Create an Administrative account</Link>
        </div>
        {error && <div style={{ color: "red" }}>{error}</div>}

        {/* Side Popup Message */}
        {showPopup && (
          <div
            style={{
              position: "fixed",
              top: 30,
              right: 30,
              minWidth: 250,
              zIndex: 120000,
              background: popupType === "success" ? "#4BB543" : "#e74c3c",
              color: "#fff",
              padding: "16px 28px",
              borderRadius: 8,
              boxShadow: "0 2px 12px rgba(0,0,0,0.15)",
              fontSize: 16,
              fontWeight: 500,
              letterSpacing: 0.2,
              transition: "all 0.3s"
            }}
          >
            {popupType === "success" ? success : error}
          </div>
        )}
      </div>
    </div>
  );
}

export default AdministrativeLogin;
